<template>
  <div class="dashboard-container">
    <!-- Loader: Top Progress Bar -->
    <div v-if="loading" class="progress-bar" :style="{ width: progress + '%' }"></div>

    <!-- Modal Pratinjau Struk Fullsize -->
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="paymentModalLabel">
              <i class="bi bi-receipt me-1"></i> Bukti Transfer Pembayaran
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center p-3">
            <img v-if="form.payment_document" :src="form.payment_document" class="img-fluid rounded" alt="Bukti Transfer">
            <p v-else class="text-muted my-4">Tidak ada bukti transfer.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Tutup</button>
          </div>
        </div>
      </div>
    </div>

    <div class="container pb-4">
      <!-- Header Halaman -->
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <div class="page-title mb-0">
          <i class="bi bi-file-earmark-check text-primary me-1"></i>
          <span>{{ isConfirm ? "Verifikasi Pembayaran" : "Form Pembayaran" }}</span>
        </div>
        <div v-if="form.status">
          <span :class="['badge', getBadgeStatusClass(form.status), 'fs-6 px-3 py-2 rounded-pill']">
            <i :class="getStatusIcon(form.status)" class="me-1"></i>
            {{ getStatusLabel(form.status) }}
          </span>
        </div>
      </div>

      <!-- Form Konfirmasi / Verifikasi -->
      <form @submit.prevent="submitForm" class="admin-form mt-2">
        <div class="row g-3">
          
          <!-- Kolom Kiri: Informasi Turnamen & Rekening -->
          <div class="col-lg-6">
            <div class="card shadow-sm border-0 h-100">
              <div class="card-header bg-light py-2 fw-bold text-secondary">
                <i class="bi bi-info-circle me-1"></i> Data Tagihan & Rekening
              </div>
              <div class="card-body">
                <!-- Turnamen -->
                <div class="mb-3">
                  <label for="tournament_id" class="form-label fw-semibold">Turnamen</label>
                  <select
                    class="form-select"
                    id="tournament_id"
                    name="tournament_id"
                    v-model="form.tournament_id"
                    disabled
                  >
                    <option value="" disabled>Pilih Turnamen</option>
                    <option v-for="tournament in tournaments" :key="tournament.id" :value="tournament.id">
                      {{ tournament.name }}
                    </option>
                  </select>
                </div>

                <!-- Nomor Invoice & Jumlah Tagihan -->
                <div class="row g-2 mb-3">
                  <div class="col-sm-6">
                    <label class="form-label fw-semibold">Nomor Invoice</label>
                    <input
                      type="text"
                      class="form-control bg-light fw-bold text-dark"
                      v-model="form.invoice_number"
                      readonly
                    />
                  </div>
                  <div class="col-sm-6">
                    <label class="form-label fw-semibold">Total Tagihan</label>
                    <input
                      type="text"
                      class="form-control bg-light fw-bold text-primary"
                      v-model="form.amount"
                      readonly
                    />
                  </div>
                </div>

                <!-- Bank Details -->
                <div class="mb-3">
                  <label class="form-label fw-semibold">Nama Bank Tujuan</label>
                  <input
                    type="text"
                    class="form-control bg-light"
                    v-model="form.bank_name"
                    readonly
                  />
                </div>

                <!-- Account Number & Name -->
                <div class="row g-2 mb-3">
                  <div class="col-sm-6">
                    <label class="form-label fw-semibold">Nomor Rekening</label>
                    <input
                      type="text"
                      class="form-control bg-light"
                      v-model="form.account_number"
                      readonly
                    />
                  </div>
                  <div class="col-sm-6">
                    <label class="form-label fw-semibold">Atas Nama Rekening</label>
                    <input
                      type="text"
                      class="form-control bg-light"
                      v-model="form.account_name"
                      readonly
                    />
                  </div>
                </div>

                <!-- Catatan Tagihan -->
                <div class="mb-0" v-if="form.notes">
                  <label class="form-label fw-semibold">Catatan</label>
                  <textarea
                    class="form-control bg-light"
                    rows="2"
                    v-model="form.notes"
                    readonly
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Kolom Kanan: Bukti Transfer & Tindakan Verifikasi -->
          <div class="col-lg-6">
            <div class="card shadow-sm border-0 h-100">
              <div class="card-header bg-light py-2 fw-bold text-secondary">
                <i class="bi bi-shield-check me-1"></i> Bukti Transfer & Verifikasi
              </div>
              <div class="card-body">
                
                <!-- Pratinjau Bukti Transfer -->
                <div class="mb-3">
                  <label class="form-label fw-semibold">Bukti Transfer Pembayaran</label>
                  <div v-if="form.payment_document" class="p-2 border rounded bg-light text-center">
                    <img
                      :src="form.payment_document"
                      class="img-fluid rounded shadow-sm cursor-pointer"
                      style="max-height: 200px; object-fit: contain;"
                      alt="Bukti Transfer"
                      @click="openModal"
                    />
                    <div class="mt-2">
                      <button type="button" class="btn btn-sm btn-outline-primary" @click="openModal">
                        <i class="bi bi-zoom-in me-1"></i> Perbesar Bukti Transfer
                      </button>
                    </div>
                  </div>
                  <div v-else class="alert alert-warning py-2 mb-0 d-flex align-items-center gap-2">
                    <i class="bi bi-exclamation-triangle-fill fs-5"></i>
                    <span>Belum ada berkas bukti transfer yang diunggah untuk tagihan ini.</span>
                  </div>
                </div>

                <!-- Upload Bukti Struk Baru (Jika diizinkan) -->
                <div class="mb-3" v-if="showUploadStruk">
                  <label for="payment_document" class="form-label fw-semibold">Unggah / Perbarui Bukti Transfer</label>
                  <input
                    class="form-control"
                    type="file"
                    id="payment_document"
                    accept="image/*"
                    @change="handleFileUpload"
                  />
                  <div class="invalid-feedback d-block" v-if="errors.payment_document">{{ errors.payment_document }}</div>
                </div>

                <!-- Tindakan Verifikasi untuk Admin / Panitia -->
                <div v-if="canConfirmPayment" class="p-3 border rounded bg-light mt-3">
                  <label class="form-label fw-bold d-block mb-2">Tindakan Verifikasi Bendahara:</label>
                  
                  <div class="d-flex gap-4 align-items-center mb-3">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="actionStatus"
                        id="statusPaid"
                        value="paid"
                        v-model="actionStatus"
                      />
                      <label class="form-check-label fw-bold text-success cursor-pointer" for="statusPaid">
                        <i class="bi bi-check-circle-fill me-1"></i> Setujui (Approve / Lunas)
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="actionStatus"
                        id="statusFailed"
                        value="failed"
                        v-model="actionStatus"
                      />
                      <label class="form-check-label fw-bold text-danger cursor-pointer" for="statusFailed">
                        <i class="bi bi-x-circle-fill me-1"></i> Tolak (Reject)
                      </label>
                    </div>
                  </div>

                  <!-- Alasan Penolakan (Muncul jika Tolak dipilih) -->
                  <div v-if="actionStatus === 'failed'" class="mt-2">
                    <label for="reject_reason" class="form-label fw-semibold text-danger">
                      Alasan Penolakan <span class="text-danger">*</span>
                    </label>
                    <textarea
                      class="form-control"
                      :class="{ 'is-invalid': errors.reject_reason }"
                      id="reject_reason"
                      rows="3"
                      v-model="form.reject_reason"
                      placeholder="Tuliskan alasan penolakan (misal: Bukti transfer tidak jelas / nominal tidak sesuai)..."
                    ></textarea>
                    <div class="invalid-feedback d-block" v-if="errors.reject_reason">{{ errors.reject_reason }}</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Tabel Anggota Tagihan (Responsif & Rapi) -->
        <div class="mt-4">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h6 class="fw-bold mb-0 text-dark">
              <i class="bi bi-people-fill me-1 text-primary"></i>
              Daftar Atlet & Kategori Tagihan ({{ validMembers.length }})
            </h6>
          </div>
          
          <div class="table-responsive border rounded bg-white shadow-sm">
            <table class="table table-hover table-striped align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th class="text-center" style="width: 50px;">#</th>
                  <th style="min-width: 140px;">Kontingen</th>
                  <th style="min-width: 160px;">Nama Atlet / Tim</th>
                  <th style="min-width: 140px;">Kategori Kejuaraan</th>
                  <th style="min-width: 140px;">Kategori Tanding / Nomor</th>
                  <th class="text-end" style="min-width: 140px;">Biaya</th>   
                </tr>
              </thead>
              <tbody>
                <tr v-for="(member, index) in validMembers" :key="member.id || index">
                  <td class="text-center text-muted">{{ index + 1 }}</td>
                  <td>{{ member.contingent?.name || member.contingent_name || '-' }}</td>
                  <td class="fw-semibold text-dark">{{ member.name || member.team_member?.name || '-' }}</td>
                  <td>{{ member.championship_category?.name || member.championshipCategory?.name || '-' }}</td>
                  <td>{{ member.match_category?.name || member.matchCategory?.name || '-' }}</td>
                  <td class="text-end fw-bold text-nowrap text-primary">
                    {{ formatNumber(member.registration_fee ?? member.amount) }}
                  </td>
                </tr>
                <tr v-if="validMembers.length === 0">
                  <td colspan="6" class="text-center text-muted py-4">
                    <i class="bi bi-inbox fs-3 d-block mb-1 text-secondary"></i>
                    Tidak ada rincian atlet pada tagihan ini.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Tombol Aksi Bawah -->
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-4 pt-3 border-top">
          <button
            type="button"
            class="btn btn-outline-secondary px-3"
            @click="$router.push('/admin/payment')"
          >
            <i class="bi bi-arrow-left me-1"></i> Kembali ke Daftar Tagihan
          </button>

          <div class="d-flex align-items-center gap-2">
            <!-- Jika Admin / Panitia dengan Izin Konfirmasi Pembayaran -->
            <template v-if="canConfirmPayment">
              <!-- Tombol Tolak jika actionStatus === 'failed' -->
              <button
                v-if="actionStatus === 'failed'"
                type="submit"
                class="btn btn-danger px-4 d-inline-flex align-items-center gap-2"
                :disabled="loading"
              >
                <i class="bi" :class="loading ? 'bi-arrow-repeat spin' : 'bi-x-circle-fill'"></i>
                <span>{{ loading ? 'Memproses...' : 'Tolak Pembayaran' }}</span>
              </button>

              <!-- Tombol Setujui jika actionStatus === 'paid' -->
              <button
                v-else
                type="submit"
                class="btn btn-success px-4 d-inline-flex align-items-center gap-2"
                :disabled="loading"
              >
                <i class="bi" :class="loading ? 'bi-arrow-repeat spin' : 'bi-check-circle-fill'"></i>
                <span>{{ loading ? 'Memproses...' : 'Setujui & Tandai Lunas' }}</span>
              </button>
            </template>

            <!-- Jika Pelatih / User yang Hanya Mengunggah Bukti -->
            <template v-else-if="permissions && permissions.includes('upload payment struk') && form.status !== 'paid'">
              <button
                type="submit"
                class="btn btn-primary px-4 d-inline-flex align-items-center gap-2"
                :disabled="loading"
              >
                <i class="bi" :class="loading ? 'bi-arrow-repeat spin' : 'bi-upload'"></i>
                <span>{{ loading ? 'Mengunggah...' : 'Kirim Bukti Pembayaran' }}</span>
              </button>
            </template>
          </div>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import { inject } from 'vue';
import { Modal } from 'bootstrap';

export default {
  name: "PaymentConfirmationForm",
  props: {
    isConfirm: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const toast = useToast();
    const permissions = inject('permissions', []);
    return { toast, permissions };
  },
  data() {
    return {
      selectedFile: null,
      tournaments: [],
      members: [],
      form: {
        invoice_number: "",
        status: "",
        tournament_id: null,
        bank_name: "",
        account_number: "",
        account_name: "",
        amount: "",
        notes: "",
        reject_reason: "",
        payment_document: null,
      },
      actionStatus: "paid", // default keputusan verifikasi: 'paid' atau 'failed'
      errors: {},
      loading: false,
      progress: 0,
      paymentId: null,
    };
  },

  computed: {
    canConfirmPayment() {
      return this.permissions && this.permissions.includes("confirm payment");
    },
    showUploadStruk() {
      // Pelatih bisa mengunggah bukti jika memiliki izin dan belum lunas
      return (
        this.permissions &&
        this.permissions.includes("upload payment struk") &&
        (!this.canConfirmPayment || this.form.status === "waiting for payment")
      );
    },
    validMembers() {
      if (!Array.isArray(this.members)) return [];
      return this.members.filter(m => m && (m.name || m.team_member?.name || m.id));
    },
  },

  created() {
    this.paymentId = this.$route.params.id;
    this.fetchActiveTournaments();

    if (this.isConfirm && this.paymentId) {
      this.fetchPaymentDetail(this.paymentId);
    } else {
      this.loadTeamMembers();
    }
  },

  watch: {
    '$route.params.id'(newId, oldId) {
      if (this.isConfirm && newId && newId !== oldId) {
        this.paymentId = newId;
        this.fetchPaymentDetail(newId);
      }
    },
  },

  methods: {
    openModal(event) {
      if (event) event.preventDefault();
      const el = document.getElementById("paymentModal");
      if (el) {
        const modal = new Modal(el);
        modal.show();
      }
    },

    handleFileUpload(event) {
      if (event.target.files && event.target.files[0]) {
        this.form.payment_document = event.target.files[0];
      }
    },

    formatNumber(value) {
      if (value == null) return "-";
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);
    },

    getStatusLabel(status) {
      const map = {
        paid: "Lunas",
        "waiting for payment": "Menunggu Pembayaran",
        "waiting for confirmation": "Menunggu Verifikasi",
        failed: "Ditolak",
        cancelled: "Dibatalkan",
      };
      return map[status] || status || "-";
    },

    getBadgeStatusClass(status) {
      const map = {
        paid: "bg-success text-white",
        "waiting for payment": "bg-warning text-dark",
        "waiting for confirmation": "bg-info text-dark",
        failed: "bg-danger text-white",
        cancelled: "bg-secondary text-white",
      };
      return map[status] || "bg-secondary text-white";
    },

    getStatusIcon(status) {
      const map = {
        paid: "bi bi-check-circle-fill",
        "waiting for payment": "bi bi-hourglass-split",
        "waiting for confirmation": "bi bi-clock-history",
        failed: "bi bi-x-circle-fill",
        cancelled: "bi bi-slash-circle-fill",
      };
      return map[status] || "bi bi-circle";
    },

    async fetchActiveTournaments() {
      try {
        const response = await axios.get("/tournaments/active");
        this.tournaments = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      } catch (error) {
        console.error("Error fetching tournaments:", error);
      }
    },

    async loadTeamMembers() {
      this.loading = true;
      try {
        const response = await axios.get("/team-members?fetch_all=false&is_payment_confirmation=true", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
        this.members = response.data?.data ?? [];
      } catch (error) {
        console.error("Error loading members:", error);
        this.members = [];
      } finally {
        this.loading = false;
      }
    },

    async fetchPaymentDetail(id) {
      this.loading = true;
      try {
        const response = await axios.get(`/billings/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });

        if (response.data) {
          const b = response.data;
          this.form = {
            invoice_number: b.invoice_number || "",
            status: b.status || "",
            tournament_id: b.tournament_id || (b.tournament ? b.tournament.id : null),
            bank_name: b.bank_name || "",
            account_number: b.account_number || "",
            account_name: b.account_name || "",
            amount: this.formatNumber(b.amount),
            notes: b.notes || "",
            reject_reason: b.reject_reason || "",
            payment_document: b.payment_document || null,
          };

          // Default keputusan verifikasi
          this.actionStatus = b.status === "failed" ? "failed" : "paid";

          // Pastikan turnamen tagihan tersedia di daftar opsi turnamen
          if (b.tournament && !this.tournaments.some(t => t.id === b.tournament.id)) {
            this.tournaments.push(b.tournament);
          }

          // Isi daftar rincian atlet dari billing_details
          this.members = b.billing_details || b.billingDetails || [];
        }
      } catch (error) {
        this.toast.error("Gagal memuat rincian pembayaran.");
        console.error("Error fetching payment details:", error);
      } finally {
        this.loading = false;
      }
    },

    async submitForm() {
      this.errors = {};
      this.loading = true;

      try {
        // Alur Admin: Konfirmasi Pembayaran (Setujui / Tolak)
        if (this.canConfirmPayment) {
          const finalStatus = this.actionStatus;

          if (finalStatus === "failed" && (!this.form.reject_reason || !this.form.reject_reason.trim())) {
            this.toast.error("Silakan isi alasan penolakan pembayaran.");
            this.errors = { reject_reason: "Alasan penolakan wajib diisi." };
            this.loading = false;
            return;
          }

          const payload = {
            status: finalStatus,
            reject_reason: finalStatus === "failed" ? this.form.reject_reason.trim() : null,
          };

          await axios.post(`/billings/${this.paymentId}/confirm-payment`, payload, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          });

          if (finalStatus === "failed") {
            this.toast.success("Pembayaran berhasil ditolak.");
          } else {
            this.toast.success("Pembayaran berhasil disetujui & diverifikasi lunas.");
          }

          this.$router.push("/admin/payment");
          return;
        }

        // Alur Pelatih: Unggah Bukti Struk Transfer
        if (this.permissions && this.permissions.includes("upload payment struk")) {
          if (!this.form.payment_document || typeof this.form.payment_document === "string") {
            this.toast.error("Silakan pilih berkas bukti transfer terlebih dahulu.");
            this.loading = false;
            return;
          }

          let formData = new FormData();
          formData.append("payment_document", this.form.payment_document);

          await axios.post(`/billings/${this.paymentId}/update-document`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "Content-Type": "multipart/form-data",
            },
          });

          this.toast.success("Bukti transfer pembayaran berhasil diunggah.");
          this.$router.push("/admin/payment");
          return;
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        const errMsg = error.response?.data?.message || "Terjadi kesalahan saat memproses data.";
        this.toast.error(errMsg);
        this.errors = error.response?.data?.errors || {};
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dashboard-container {
  padding: 1.5rem 1rem;
}

.page-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-dark, #1f2937);
}

.cursor-pointer {
  cursor: pointer;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background: var(--grad-flame, #e84808);
  animation: loader-animation 1.5s infinite;
}

@keyframes loader-animation {
  0% { width: 0; }
  50% { width: 50%; }
  100% { width: 100%; }
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
